import React, { useState, useEffect } from 'react';
import { FaWhatsapp, FaTimes, FaClock, FaQuestionCircle } from 'react-icons/fa';
import './WhatsAppIcon.css';

const WHATSAPP_CONFIG = {
  phoneNumber: '+9779741761409', // Replace with your WhatsApp number
  businessName: 'NepliShop Support',
  businessHours: {
    start: 9, // 9 AM
    end: 18,  // 6 PM
    days: [1, 2, 3, 4, 5, 6] // Monday to Saturday (0 = Sunday)
  },
  timezone: 'Asia/Kathmandu'
};

const WhatsAppWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isBusinessHours, setIsBusinessHours] = useState(true);
  const [message, setMessage] = useState('');

  // Check business hours
  useEffect(() => {
    const checkBusinessHours = () => {
      const now = new Date();
      const currentHour = now.getHours();
      const currentDay = now.getDay();
      
      const isWithinHours = currentHour >= WHATSAPP_CONFIG.businessHours.start && 
                           currentHour < WHATSAPP_CONFIG.businessHours.end;
      const isWorkingDay = WHATSAPP_CONFIG.businessHours.days.includes(currentDay);
      
      setIsBusinessHours(isWithinHours && isWorkingDay);
    };

    checkBusinessHours();
    const interval = setInterval(checkBusinessHours, 60000); // Check every minute
    
    return () => clearInterval(interval);
  }, []);

  const handleWhatsAppClick = () => {
    if (!isBusinessHours && !isOpen) {
      setIsOpen(true);
      return;
    }
    
    const defaultMessage = message || 'Hello! I need assistance with your products.';
    const formattedMessage = encodeURIComponent(`${defaultMessage}\n\nWebsite: ${window.location.href}`);
    const whatsappUrl = `https://wa.me/${WHATSAPP_CONFIG.phoneNumber.replace(/\D/g, '')}?text=${formattedMessage}`;
    
    window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    
    if (isOpen) {
      setIsOpen(false);
      setMessage('');
    }
  };

  const handleClosePopup = () => {
    setIsOpen(false);
    setMessage('');
  };


  return (
    <div className="whatsapp-widget-container">
      {/* Main WhatsApp Button */}
      <button 
        className={`whatsapp-main-btn ${!isBusinessHours ? 'off-hours' : ''}`}
        onClick={handleWhatsAppClick}
        aria-label="Contact us on WhatsApp"
        title={isBusinessHours ? "Chat with us on WhatsApp" : "Outside business hours"}
      >
        <FaWhatsapp className="whatsapp-icon-main" />
        {!isBusinessHours && <FaClock className="clock-icon" />}
      </button>

      {/* Popup for outside business hours */}
      {isOpen && !isBusinessHours && (
        <div className="whatsapp-popup">
          <div className="popup-header">
            <h4>NEPLISHOP</h4>
            <button 
              className="close-btn" 
              onClick={handleClosePopup}
              aria-label="Close"
            >
              <FaTimes />
            </button>
          </div>
          
          <div className="popup-content">
           
            
            <div className="business-hours">
              <strong>Business Hours:[9 - 20]</strong>
          
            </div>
            
            <div className="message-section">
              <label htmlFor="whatsapp-message">
                <FaQuestionCircle /> Leave a message:
              </label>
              <textarea
                id="whatsapp-message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Type your message here..."
                rows="3"
              />
            </div>
            
            <div className="popup-actions">
              <button 
                className="cancel-btn"
                onClick={handleClosePopup}
              >
                Cancel
              </button>
              <button 
                className="send-btn"
                onClick={handleWhatsAppClick}
                disabled={!message.trim()}
              >
                Send Message
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WhatsAppWidget;
